export const getFileExtension = (fileName: string) => {
  return fileName.split('.').pop();
};

export const formatExtensions = (extensions: string[]) => {
  return extensions.map((ext) => `.${ext}`).join(', ');
};

export const isFileExists = (files: File[], inputFiles: File[]) => {
  return files.some(
    (f) =>
      inputFiles.filter((ipFile) => ipFile.name.toLowerCase() === f.name.toLowerCase()).length >
      0
  );
};

export const loadFileTypeIcon = (type) => {
  const ext = getFileExtension(type);
  let iconClass = 'icon-file-empty';
  switch (ext) {
    case 'pdf':
      iconClass = 'icon-pdf';
      break;
    case 'xlsx':
    case 'xls':
      iconClass = 'icon-file-excel';
      break;
    case 'jpg':
    case 'jpeg':
    case 'png':
      iconClass = 'icon-file-img';
      break;

    default:
      iconClass = 'icon-file-empty';
  }
  return iconClass;
};

export const getFilesSize = (files: File[]) => {
  return files.reduce((acc, file) => acc + file.size, 0) / Math.pow(1024, 2);
}

export const isValidExtension = (files: File[], extensions: string[]) => {
  return files.every((file) => extensions.includes(getFileExtension(file.name)));
}